<template>
  <div>
    <!-- Alert message -->
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <span>
      <header-component :headerTitle="headerText" />
    </span>
     <!-- seacrh, action button and filter -->
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-0">
      <!-- Search fields -->
      <v-row class="ma-1">
          <v-spacer></v-spacer>
        <v-card-actions class="mb-4">
          <v-btn class="mr-2 custum-button text-none" variant="flat" color="primary" @click="navigateToFileUpload" large style="min-height:55px; min-width:100px; font-weight:600;">Upload</v-btn>
        </v-card-actions>
      </v-row>
    </v-card-title>
    <v-card class="v-card-100 mt-4">
      <v-card-text style="padding: 32px">
        <v-row>
          <v-col cols="3" class="pt-7 text-left">
            <span style="font-weight: 600">Location From</span>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              color="primary"
              label="Select Location"
              v-model="selected_location"
              :items="locationList"
              item-title="name"
              item-value="id"
              variant="outlined"
              class="text-left"  
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="v-card-100">
      <v-card-text style="padding: 32px">
        <v-row class="m-0">
          <v-col cols="3" class="pt-7 text-left">
            <span style="font-weight: 600">Disposition Type</span>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              color="primary"
              label="Select Disposition Type"
              v-model="selected_dispoType"
              :items="dispo_type_List"
              @update:modelValue="fetchDisposition"
              variant="outlined"
              class="text-left"
              disabled 
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="v-card-100 mt-4">
      <v-card-text style="padding: 32px">
        <v-row>
          <v-col cols="3" class="pt-7 text-left">
            <span style="font-weight: 600">Disposition</span>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              color="primary"
              label="Select Disposition"
              v-model="selected_dispos"
              :items="dispos_list"
              item-title="original_code"
              return-object
              @update:modelValue="fetchStage"
              variant="outlined"
              class="text-left"  
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="v-card-100 mt-4">
      <v-card-text style="padding: 32px">
        <v-row>
          <v-col cols="3" class="pt-7 text-left">
            <span style="font-weight: 600">Stage</span>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              color="primary"
              label="Select Disposition Stage"
              v-model="selected_stage"
              :items="stageList"
              variant="outlined"
              class="text-left"  
            ></v-autocomplete>
          </v-col>
        </v-row>
         <v-row>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="float-right text-none"
            @click="proceedButton"
            :disabled="!selected_location || !selected_dispoType || !selected_stage || !selected_dispos"
            >Proceed</v-btn
          >
        </v-row>
      </v-card-text>
    </v-card>

    <!-- <v-card class="v-card-96 mt-4">
      <v-card-text style="padding: 32px">
        <v-row>
          <v-col cols="3" class="pt-7 text-left">
            <span style="font-weight: 600">Location</span>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              color="primary"
              label="Select Location"
              v-model="selected_location"
              :items="locationList"
              item-title="name"
              item-value="id"
              variant="outlined"
              class="text-left"  
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn
            :color="(!selected_location || !selected_dispoType) ? 'grey' : 'primary'"
            class="float-right"
            @click="proceedButton"
            :disabled="!selected_location || !selected_dispoType"
            >Proceed</v-btn
          >
        </v-row>
      </v-card-text>
    </v-card> -->
  </div>
</template>
<script>
import HeaderComponent from "./../../../../commoncomponents/HeaderComponent";
import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess'

export default {
  components: {
    HeaderComponent,
  },

  data() {
    return {
      headerText: "Transfer",
      alert_type: "success",
      alert: false,
      alert_message: "",
      selected_dispoType: null,
      dispo_type_List: [],
      selected_dispos: null,
      dispos_list: [],
      selected_stage: null,
      stageList: [],
      selected_location: null,
      locationList: [],
    };
  },
  async created() {
    this.scrollToTop();
    const role = this.$store.state.currentUser.roles[0]
    if(role in module_that_allowed && moduleAccessFunc(role,'Transfer')){
      signout()
      return;
    }
    this.fetchDestination();
    // this.fetchDisposition();
    this.fetchLocation();
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    proceedButton() {
      let disp = "";
      if (this.selected_dispos.original_code) {
        disp = this.selected_dispos.original_code;
      }
      this.$store.commit("transferSelectedLot", {
        disposition: disp,
        locationId: this.selected_location,
        status: this.selected_stage,
        dispo_type: this.selected_dispoType,
      });
      this.$router.push({ name: "TransferTablePage" });
    },
    fetchDestination() {
      this.$httpSecured
        .get("/api/v1/transfer_inventories/dispositions_type")
        .then((response) => {
          if (response.data) {
            this.dispo_type_List = response.data.disposition_type;
            this.selected_dispoType = "Reverse Disposition";
            this.fetchDisposition();
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    fetchDisposition() {
      this.$httpSecured
        .get("/api/v1/transfer_inventories/dispositions", {
          params: { disposition_type: this.selected_dispoType },
        })
        .then((response) => {
          if (response.data) {
            this.dispos_list = response.data.dispositions;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    fetchStage() {
      this.selected_stage = null;
      this.$httpSecured
        .get(
          "/api/v1/transfer_inventories/dispositions_sub_status?disposition_id=" +
            this.selected_dispos.id,
        )
        .then((response) => {
          if (response.data) {
            this.stageList = response.data.statuses;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    fetchLocation() {
      this.$httpSecured
        .get("/api/v1/distribution_centers")
        .then((response) => {
          if (response.data) {
            this.locationList = response.data.distribution_centers.map(item => ({
              ...item,
              name: `${item.code} (${item.name})`,
            }))

          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    navigateToFileUpload() {
          this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: "",
          action:''
        });      
        this.$router.push({ name: "LotFileuploadComm" });
      },
  },
};
</script>
